import { Video, CreditCard, Home, Sparkles, Scale, Banknote, Target, Hammer, HeartPulse, Rocket } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export function WhoFor() {
  const { t } = useI18n();
  const items = [
    { icon: Video, labelKey: "whofor.creators.label", descKey: "whofor.creators.desc" },
    { icon: CreditCard, labelKey: "whofor.credit.label", descKey: "whofor.credit.desc" },
    { icon: Home, labelKey: "whofor.realestate.label", descKey: "whofor.realestate.desc" },
    { icon: Sparkles, labelKey: "whofor.medspa.label", descKey: "whofor.medspa.desc" },
    { icon: Scale, labelKey: "whofor.lawyers.label", descKey: "whofor.lawyers.desc" },
    { icon: Banknote, labelKey: "whofor.finance.label", descKey: "whofor.finance.desc" },
    { icon: Target, labelKey: "whofor.coaches.label", descKey: "whofor.coaches.desc" },
    { icon: Hammer, labelKey: "whofor.contractors.label", descKey: "whofor.contractors.desc" },
    { icon: HeartPulse, labelKey: "whofor.health.label", descKey: "whofor.health.desc" },
    { icon: Rocket, labelKey: "whofor.any.label", descKey: "whofor.any.desc" },
  ];
  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            {t("whofor.title.1")} <span className="text-gradient-orange">{t("whofor.title.2")}</span> {t("whofor.title.3")}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">{t("whofor.subtitle")}</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {items.map(({ icon: Icon, labelKey, descKey }) => (
            <div
              key={labelKey}
              className="group relative p-6 rounded-2xl bg-card border border-border hover:border-primary/50 transition-all hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition">
                <Icon className="w-6 h-6 text-primary" />
              </div>
              <p className="font-semibold text-sm leading-tight mb-1">{t(labelKey)}</p>
              <p className="text-xs text-muted-foreground leading-snug">{t(descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
